import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { Routes, RouterModule, Router } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import { UserService } from 'src/app/services/user.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-login-recover-passwd',
  templateUrl: './login-recover-passwd.component.html',
  styleUrls: ['./login-recover-passwd.component.scss']
})
export class LoginRecoverPasswdComponent implements OnInit {
  cardForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toast: ToastService,
    private userService: UserService,
    private translate:TranslateService) {
    this.cardForm = fb.group({
      // materialFormCardNameEx: ['', Validators.required],
      email: ['', [Validators.email, Validators.required]],
      // materialFormCardConfirmEx: ['', Validators.required],
      // materialFormCardPasswordEx: ['', Validators.required]
    });
  }
  ngOnInit() {
  }

  resetPass() {
    let value = this.cardForm.value;
    console.log(this.cardForm.value);
    this.userService.recoverPassword(value.email).subscribe(result => {
      console.log(result);
      if (result.response == 0) {
        this.toast.success(this.translate.instant('msgRecPassSucc'));
        this.router.navigateByUrl('/login');
      } else {
        this.toast.error('An error has ocurred or Email is not valid');
      }
    })
  }

}
